import { render, staticRenderFns } from "./CPTemp1.vue?vue&type=template&id=4980565c&scoped=true&"
import script from "./CPTemp1.vue?vue&type=script&lang=js&"
export * from "./CPTemp1.vue?vue&type=script&lang=js&"
import style0 from "./CPTemp1.vue?vue&type=style&index=0&id=4980565c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4980565c",
  null
  
)

export default component.exports